var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlert32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C31.9899231,24.8323786 24.8323786,31.9899231 16,32 C7.163444,32 -1.13686838e-13,24.836556 -1.13686838e-13,16 C-1.13686838e-13,7.163444 7.163444,0 16,0 Z M16,2.28571429 C8.42580915,2.28571429 2.28571429,8.42580915 2.28571429,16 C2.28571429,23.5741909 8.42580915,29.7142857 16,29.7142857 C23.5741909,29.7142857 29.7142857,23.5741909 29.7142857,16 C29.7060973,8.42920348 23.5707965,2.29390268 16,2.28571429 Z M15.9851429,21 C17.247508,21 18.2708571,22.0233491 18.2708571,23.2857143 C18.2708571,24.5480794 17.247508,25.5714286 15.9851429,25.5714286 C14.7227777,25.5714286 13.6994286,24.5480794 13.6994286,23.2857143 C13.6994286,22.0233491 14.7227777,21 15.9851429,21 Z M15.9857143,6.39485714 C17.061565,6.39485714 17.9337143,7.26700645 17.9337143,8.34285714 L17.5497143,18.2445714 C17.5850163,18.8308939 17.2922645,19.3884344 16.7895638,19.6922638 C16.2868631,19.9960932 15.6571369,19.9960932 15.1544362,19.6922638 C14.6517355,19.3884344 14.3589837,18.8308939 14.3942857,18.2445714 L14.0377143,8.34285714 C14.0377143,7.26700645 14.9098636,6.39485714 15.9857143,6.39485714 Z",
    id: "Combined-Shape-Copy",
    fill: "#C73500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlert32);
export default __webpack_public_path__ + "static/media/messageAlert32.355a6eea768a39278e35bdbb5480af52.svg";
export { ForwardRef as ReactComponent };